import { render, staticRenderFns } from "./QuestionPlanEdit.vue?vue&type=template&id=5b48b753&scoped=true&"
import script from "./QuestionPlanEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48b753",
  null
  
)

export default component.exports